import { createReducer, on } from "@ngrx/store";
import { billActions } from "../bill.actions";

export const initialState: string[] = [];

export const billsDownloadReducer = createReducer(
    initialState,
    on(billActions.downloadBillsSuccess, (state, {payload}) => payload),
    on(billActions.clearDownloadBills, (state) => initialState)
)